// @flow
import React from "react";

interface HelpLinkProps {
    tooltip?: string,
    small?: boolean,
    medium?: boolean,
    onHelpClicked?: Function,
}

const HelpWithOnClick: React.FC<HelpLinkProps> = ({tooltip="click to see help",
                                                      onHelpClicked, small, medium}) => {
    
    let sizeClass = "fa-3x";
    if(small) {
        sizeClass="fa-1x";
    }
    else if(medium) {
        sizeClass="fa-2x";
    }
    
    const handleOnClick = () => {
        if(onHelpClicked) onHelpClicked();
    }
    
    return(
        <i className={"fa fa-question-circle-o li-fg-primary li-pointer "+sizeClass}
           onClick={handleOnClick}
           data-toggle="tooltip" title={tooltip}/>
    );
}

export default HelpWithOnClick;